import { Inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { tap, catchError } from 'rxjs/operators';
import { TelemetryService } from '../../../../node_modules/@infosys-it/angular-telemetry-sdk';
//import { AuthenticationService } from '@app/_services';
// to get KeyCloak Token

import { NgxUiLoaderService } from 'ngx-ui-loader';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  token: any;
  constructor(
    @Inject(TelemetryService) private _telemetryService: TelemetryService,
    private ngxLoader: NgxUiLoaderService,
  ) {
    this.token = localStorage.getItem('access-token');
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with basic auth credentials if available
    const token = localStorage.getItem('access-token');
    if (token) {
      // console.log('woow interceptor', token);
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    // return next.handle(request);
    return next.handle(request).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          if (evt.body && evt.body.success) {
            console.log(evt.body.success);
          }
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          const telemetryError = {
            // Required
            err: err.status, // Required. Error code
            errtype: 'APIERROR', // Required. Error type classification - "SYSTEM", "MOBILEAPP", "CONTENT"
            stacktrace: err.error, // Required. Detailed error data/stack trace
          };
          this._telemetryService.error(telemetryError);
          if (
            err.url.includes('elasticCandidate/searchCandidatesCopy') ||
            err.url.includes('elasticCandidate/searchCandidatesFilter')
          ) {
            return throwError(err);
          }
          if (
            err.url.includes('admin/editEventDetails') ||
            err.url.includes('admin/createEvent') ||
            err.url.includes('events/viewEventDetails') ||
            err.url.includes('admin/deleteEventByUnit')
          ) {
            return throwError(err);
          }
        }
        //log error
        return throwError(err);
      }),
    );
  }
}
